const THREE_POINT_ATTEMPT_ALIASES = Object.freeze([
  "3-PT Attempted",
  "3PT Attempted",
  "3PT Attempts",
  "3-Pointers Attempted",
  "Three Pointers Attempted",
  "3PTA",
  "3PA",
]);

const normalize = (value) => String(value || "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");
const threePointAttemptLabels = new Set(THREE_POINT_ATTEMPT_ALIASES.map(normalize));

export { THREE_POINT_ATTEMPT_ALIASES };

export function isWnbaThreePointAttempts(propType) {
  return threePointAttemptLabels.has(normalize(propType));
}

export function getWnbaThreePointAttempts(row, propType) {
  if (!isWnbaThreePointAttempts(propType)) return { applicable: false, value: null };

  const indexed = Object.fromEntries(
    Object.entries(row || {}).map(([key, value]) => [normalize(key), value])
  );
  for (const alias of THREE_POINT_ATTEMPT_ALIASES) {
    const raw = indexed[normalize(alias)];
    if (raw === null || raw === undefined || raw === "") continue;
    const value = Number(raw);
    if (Number.isFinite(value)) return { applicable: true, value };
  }
  return { applicable: true, value: null };
}
